<template>
  <AbstractPop>
    <template v-slot>
      <div class="dialog">
        <header class="dialog-header">
          <h2 class="dialog-title">그룹등록</h2>
          <p>
            제품 그룹은 최대 20개까지 설정 가능하며,<br />
            그룹당 최대 200개까지 제품등록이 가능합니다.<br />
            그룹명은 최대 10글자 까지 설정 가능합니다.
          </p>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            ×
          </button>
        </header>

        <div class="dialog-content dialog-content-2">
          <!-- 새 그룹 추가 -->
          <div class="add-group-form" id="addGroupForm">
            <p class="add-group-form-txt">+ 새 그룹 추가</p>
            <div>
              <input
                type="text"
                class="group-input"
                placeholder="그룹명 작성 후 등록해주세요"
                v-model="data.groupName"
                maxlength="10"
                @input="checkGroupNameLangth"
                id="groupNameInput"
              />
              <div class="form-buttons">
                <button
                  type="button"
                  class="form-btn cancel"
                  id="cancelBtn"
                  @click="data.groupName = ''"
                >
                  취소
                </button>
                <button
                  type="button"
                  class="form-btn confirm"
                  @click="btnNewName()"
                  id="confirmBtn"
                >
                  확인
                </button>
              </div>
            </div>
          </div>

          <!-- 카테고리 섹션 -->
          <div class="category-section">
            <ul class="category-list">
              <template v-if="data.grouptList.length > 0">
                <li
                  class="category-item"
                  v-for="item in data.grouptList"
                  :key="item.groupSn"
                >
                  <span class="category-name" v-if="!item.saveMode">{{
                    item.groupName
                  }}</span>
                  <input
                    type="text"
                    class="category-name-input"
                    v-model="item.groupName"
                    v-if="item.saveMode"
                    style="background-color: darkgrey"
                    maxlength="10"
                  />

                  <div class="category-actions" v-if="item.saveMode">
                    <button
                      type="button"
                      class="action-btn edit"
                      @click="btnSaveItem(item)"
                    >
                      저장
                    </button>
                    <button
                      type="button"
                      class="action-btn delete"
                      @click="btnCancel(item)"
                    >
                      취소
                    </button>
                  </div>

                  <div class="category-actions" v-if="!item.saveMode">
                    <button
                      type="button"
                      class="action-btn edit"
                      @click="btnSaveOn(item)"
                    >
                      수정
                    </button>
                    <button
                      type="button"
                      class="action-btn delete"
                      @click="btnDeleteItem(item)"
                    >
                      삭제
                    </button>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>

        <div class="dialog-footer">
          <button type="button" class="close-btn" @click="() => emits('close')">
            × 창닫기
          </button>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>
</template>
<script setup>
import { onMounted, defineEmits, reactive, inject } from "vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import { api } from "@/plugins/api";
import * as cmUtil from "@/utils/cmUtil";
import utils from "@/js/utils";

const url = inject("url_prefix");
const data = reactive({
  groupName: "",
  grouptList: [],
});
let initData = {
  list: { grouptList: [] },
};

const emits = defineEmits(["close", "groupUpdate"]);

/*화면 로드시작 이벤트*/
onMounted(() => {
  selectGroupList();
});

async function selectGroupList() {
  const res = await api.post(`${url}/myRoom/group/select`);
  if (res.resultCode === 200) {
    data.grouptList = res.data;

    let arrayData = new Array();
    let arrayData2 = new Array();
    for (var key in res.data) {
      res.data[key]["saveMode"] = false;
      arrayData.push(JSON.parse(JSON.stringify(res.data[key])));
      arrayData2.push(JSON.parse(JSON.stringify(res.data[key])));
    }
    data.grouptList = arrayData;
    initData.list.grouptList = arrayData2;
    emits("groupUpdate", arrayData2);
  }
}

//글자 수 체크
async function checkGroupNameLangth() {
  const inputBox = document.getElementById('groupNameInput');
  
  inputBox.addEventListener('input', () => {
    // 여기에 실행할 함수 내용을 작성하세요
  const value = inputBox.value;
  const length = value.length;

  
  if (length > 10) {
      inputBox.value = value.slice(0, 10);
      cmUtil.alert('그룹명은 최대 10글자 까지 가능합니다.');
    }


  });

  
}

/*신규 그룹명 추가*/
async function btnNewName() {
  if (utils.isBlank(data.groupName)) {
    await cmUtil.alert("그룹명칭을 입력하십시오.");
    return;
  }

  cmUtil.loading("", { duration: 60000 });

  const res = await api.post(`${url}/myRoom/group/insert`, {
    groupName: data.groupName,
  });
  cmUtil.loadingHide();
  if (res.resultCode === 200) {
    await cmUtil.alert("저장되었습니다.");
    data.groupName = "";
    selectGroupList();
  }
}

async function btnSaveItem(item) {
  if (utils.isNotBlank(item)) {
    cmUtil.loading("", { duration: 60000 });

    const res = await api.post(`${url}/myRoom/group/update`, item);

    cmUtil.loadingHide();

    if (res.resultCode === 200) {
      await cmUtil.alert("변경 되었습니다.");
      selectGroupList();
    }
  } else {
    cmUtil.alert("선택된 그룹의 정보가 없습니다.");
  }
}

async function btnDeleteItem(item) {
  if (utils.isNotBlank(item)) {
    if (
      await cmUtil.confirm(item.groupName + " 카테고리를 삭제하시겠습니까?")
    ) {
      cmUtil.loading("", { duration: 60000 });

      const res = await api.post(`${url}/myRoom/group/delete`, item);

      cmUtil.loadingHide();

      if (res.resultCode === 200) {
        await cmUtil.alert(item.groupName + " 카테고리가 삭제되었습니다.");
        selectGroupList();
      }
    }
  } else {
    cmUtil.alert("선택된 그룹의 정보가 없습니다.");
  }
}

async function btnSaveOn(item) {
  for (let key in data.grouptList) {
    if (data.grouptList[key].groupSn == item.groupSn) {
      data.grouptList[key].saveMode = true;
    } else {
      data.grouptList[key].saveMode = false;
      data.grouptList[key].groupName = initData.list.grouptList[key].groupName;
    }
  }
}

async function btnCancel(item) {
  data.grouptList = initData.list.grouptList;
  item.saveMode = false;
}
</script>
